import { brandPalette } from '@/constants/colors'
import { marketPresentation } from '@/config/marketPresentation'

export const brandTheme = brandPalette(marketPresentation.branding.primaryColor)
